import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import AuthorForm from './forms/authorForm';
import AuthorList from './lists/authorList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class authorEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    key={1}
                    theme="default"
                    header={"Szerzők"}
                    footer={[
                        <Button key="0" disabled={this.props.isLoading} color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <AuthorList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    key={2}
                    theme="default"
                    header={this.props.values.name || "Új szerző"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <AuthorForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "author", WrappedComponent: authorEditor, props: {view: "admin"}});
